module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/fees.json
// module id = 370
// module chunks = 134151130358990